export default "__VITE_ASSET__BPH48IJH__"